import { createAction } from 'redux-actions';
import {
  getActiveSessions,
  revokeSession as revokeSessionRequest,
  revokeAllOtherSessions as revokeAllOtherSessionsRequest,
  clearActiveSessionsStorage,
  dismissActiveSessionsPrompt,
} from '../../service/activeSessionsService';
import { actionTypes } from './actionTypes';

const {
  login: { SET_ACTIVE_SESSIONS, CLEAR_ACTIVE_SESSIONS },
} = actionTypes;

export const setActiveSessionsAction = createAction(SET_ACTIVE_SESSIONS);
export const clearActiveSessionsAction = createAction(CLEAR_ACTIVE_SESSIONS);

export const fetchActiveSessions = () => async (dispatch) => {
  const data = await getActiveSessions();
  if (data?.sessions) {
    dispatch(setActiveSessionsAction(data));
  }
  return data;
};

export const revokeSession = (sub) => async (dispatch) => {
  const data = await revokeSessionRequest(sub);
  if (data) {
    dispatch(setActiveSessionsAction(data));
  }
  return data;
};

export const revokeAllOtherSessions = () => async (dispatch) => {
  const data = await revokeAllOtherSessionsRequest();
  if (data) {
    dispatch(setActiveSessionsAction(data));
  }
  return data;
};

export const dismissActiveSessionsModal = () => () => {
  dismissActiveSessionsPrompt();
};

export const clearActiveSessions = () => (dispatch) => {
  clearActiveSessionsStorage();
  dispatch(clearActiveSessionsAction());
};

export default {
  fetchActiveSessions,
  revokeSession,
  revokeAllOtherSessions,
  dismissActiveSessionsModal,
  clearActiveSessions,
};
